import { useEffect, useState } from 'react';
import { fetchPublicSettings, invalidatePublicSettingsCache } from './publicSettingsCache';

// ¿Está abierto el registro de médicos? Lo abre y cierra el admin desde el
// panel. Mientras carga (o si falla) se trata como cerrado: es preferible no
// mostrar "Soy médico" un instante a mostrarlo cuando está cerrado. El backend
// rechaza igual el registro de médicos si está cerrado.
export default function useDoctorRegistrationOpen() {
  const [state, setState] = useState({ open: false, loading: true });

  useEffect(() => {
    let alive = true;
    fetchPublicSettings().then((s) => {
      if (alive) setState({ open: s?.doctorRegistrationOpen === true, loading: false });
    });
    return () => { alive = false; };
  }, []);

  return state;
}

// Olvida la respuesta guardada: tras cambiar el interruptor en el panel, y en tests.
export const invalidateDoctorRegistrationCache = invalidatePublicSettingsCache;
